import { ModalStyled } from '../../Modals.styled';
import { modalStyles } from '../../ModalStyles';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../setup';
import { KTSVG } from '../../../../_metronic/helpers';
import { Backdrop, Fade, MenuItem, TextField, CircularProgress } from '@mui/material';
import { UserModel } from '../../../modules/auth/models/UserModel';
import { useEffect, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { stylesMUIInput } from '../../stylesMUIInput';
import { useStyles } from '../FreightInfo/FreightInformation/FreightInformationStyles';
import axios from 'axios';
import { checkErrorAPICall } from '../../../helpers/checkErrorAPICall';
import { NumberFormatStyled } from '../../Inputs.styled';
import InsuranceErrorModal from './InsuranceErrorModal';

const GET_COMMODITIES = '/api/v1/tools/redkik/commodities'
const GET_COVERTYPES = '/api/v1/tools/redkik/covertypes'
const CREATE_QUOTE_REDKIK = '/api/v1/tools/redkik/createquote'

const InsuranceModal = ({open, setOpen, formikValues, formik, setFormikValues, accessorialSelected, setAccessorialSelected, setOpenClearRateToEditModal, setNewValuesWhenRateCleared, setOpenErrorsInPageModal, setTouchedDate, setSelectedAcc}) => {
    const dispatch = useDispatch()
    const classes = modalStyles({})
    const classesInput = useStyles({props: {}})
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const [commodities, setCommodities] = useState([])
    const [coverTypes, setCoverTypes] = useState([])
    const [loading, setLoading] = useState(false)
    const [restError, setRestError] = useState(null)
    const [values, setValues] = useState({
        commodity: '',
        insuranceAmount: null,
        insuranceFreight: false,
        insuranceAddOn: false,
        accId: null,
        typeName: '',
        coverTypeInsurance: ''
    })
    const [errorCargoValue, setErrorCargoValue] = useState(false)
    const [errorCommodity, setErrorCommodity] = useState(false)
    const [errorCoverType, setErrorCoverType] = useState(false)
    const [insuranceAmount, setInsuranceAmount] = useState(null)
    const [insuranceFreight, setInsuranceFreight] = useState(undefined)
    const [insuranceAddOn, setInsuranceAddOn] = useState(undefined)
    const [isSavingInsurance, setIsSavingInsurance] = useState(false)
    const [openInsuranceErrorModal, setOpenInsuranceErrorModal] = useState(false)
    const [insuranceErrorMessage, setInsuranceErrorMessage] = useState('')

    const handleCloseModal = () => {
        setOpen(false)
        setInsuranceErrorMessage('')
        setTimeout(() => {
            setValues({
                commodity: '',
                coverTypeInsurance: '',
                typeName: '',
                insuranceAmount: null,
                insuranceFreight: false,
                insuranceAddOn: false,
                accId: null
            })
            setErrorCargoValue(false)
            setErrorCommodity(false)
            setErrorCoverType(false)
        }, 300);
    }

    const setInsuranceValuesInFormik = () => {
        let index = formikValues?.moneyAccessorialsInformation?.map(a => a.accId)?.indexOf(values.accId)     

        if(index > -1){            
            setFormikValues(`moneyAccessorialsInformation[${index}]`, {
                insuranceAmount: values?.insuranceAmount,
                insuranceFreight: values?.insuranceFreight,
                insuranceAddOn: values?.insuranceAddOn,
                commodityInsurance: values?.commodity,
                accId: values?.accId,
                typeName: values?.typeName,
                coverTypeInsurance: values?.coverTypeInsurance,
            })
        }
         else{            
            setFormikValues('moneyAccessorialsInformation', [
                ...(formikValues?.moneyAccessorialsInformation?.length ? formikValues?.moneyAccessorialsInformation : []),
                {
                    insuranceAmount: values?.insuranceAmount,
                    insuranceFreight: values?.insuranceFreight,
                    insuranceAddOn: values?.insuranceAddOn,
                    commodityInsurance: values?.commodity,
                    accId: accessorialSelected.id,
                    typeName: accessorialSelected.typeName,
                    coverTypeInsurance: values?.coverTypeInsurance,
                }
            ])
        }
        

       // if(true) {
        let payload = {}
        setIsSavingInsurance(true)
        let dateValue = formikValues.pickupDate?.date ? new Date(formikValues.pickupDate?.date).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10)

        if(!formikValues.pickupDate) {
            setFormikValues('pickupDate', new Date())
        }
        
            if(formikValues.shipper?.city && formikValues.consignee?.city) {
                payload = {
                    originCity: formikValues.shipper?.city,
                    originState: formikValues.shipper?.state,
                    originZipcode: formikValues.shipper?.zipcode,
                    originCountry: formikValues.shipper?.country,
                    destinationCity: formikValues.consignee?.city,
                    destinationState: formikValues.consignee?.state,
                    destinationZipcode: formikValues.consignee?.zipcode,
                    destinationCountry: formikValues.consignee?.country,
                    commodityInsurance: values?.commodity,
                    insuranceAmount: values?.insuranceAmount,
                    insuranceFreight: values?.insuranceFreight,
                    insuranceAddOn: values?.insuranceAddOn,
                    coverTypeInsurance: values?.coverTypeInsurance,
                    pickupDate: dateValue,
                    conveyanceType: "LAND"
                }
            }
            else if(formikValues.origin?.City || formikValues.destination?.City) {
                payload = {
                    originCity: formikValues.origin?.City,
                    originState: formikValues.origin?.State,
                    originZipcode: formikValues.origin?.Zipcode,
                    originCountry: formikValues.origin?.Country,
                    destinationCity: formikValues.destination?.City,
                    destinationState: formikValues.destination?.State,
                    destinationZipcode: formikValues.destination?.Zipcode,
                    destinationCountry: formikValues.destination?.Country,
                    commodityInsurance: values?.commodity,
                    insuranceAmount: values?.insuranceAmount,
                    insuranceFreight: values?.insuranceFreight,
                    insuranceAddOn: values?.insuranceAddOn,
                    coverTypeInsurance: values?.coverTypeInsurance,
                    pickupDate: dateValue,
                    conveyanceType: "LAND"
                }
            }  
            
            if((formikValues.shipper?.city || formikValues.origin?.City) && (formikValues.consignee?.city || formikValues.destination?.City)) {
                setFormikValues('moneyAccessorialsInformation[0]',                 
                    {
                        insuranceAmount: values?.insuranceAmount,
                        insuranceFreight: values?.insuranceFreight,
                        insuranceAddOn: values?.insuranceAddOn,
                        commodityInsurance: values?.commodity,
                        coverTypeInsurance: values?.coverTypeInsurance,
                        accId: accessorialSelected.id,
                        typeName: accessorialSelected.typeName
                    }
                )

                
                //if(values?.insuranceAddOn) {
                    formik.setFieldValue(`insuranceAddOn`, (values?.insuranceAddOn || false))
                //}
                if(values?.insuranceAmount) {
                    formik.setFieldValue(`insuranceAmount`, values?.insuranceAmount)
                }
                // if(values?.insuranceFreight) {
                    formik.setFieldValue(`insuranceFreight`, (values?.insuranceFreight || false))
                // }
                if(values?.commodity) {
                    formik.setFieldValue(`commodityInsurance`, values?.commodity)
                }

                if(values?.coverTypeInsurance) {
                    formik.setFieldValue(`coverTypeInsurance`, values?.coverTypeInsurance)
                }

                if(user?.redkikEnabled && accessorialSelected?.code == 'INS' && !values?.insuranceFreight) {
                    axios.post(CREATE_QUOTE_REDKIK, 
                        payload
                    ).then(result => {
                        if(result.data.data.results.redkikQuoteId) {
                            setFormikValues('redkikQuoteId',result.data.data.results.redkikQuoteId)
                            setOpen(false)
                            setIsSavingInsurance(false)
                        }

                    }).catch(error => {
                        setOpen(false)
                        setInsuranceAmount(null)
                        const errorMessage = error?.response?.data?.error?.message || 'Insurance Error, contact your broker'
                        setInsuranceErrorMessage(errorMessage)
                        setOpenInsuranceErrorModal(true)
                        setTimeout(() => {                    
                            setIsSavingInsurance(false)
                            setInsuranceFreight(undefined)
                            setInsuranceAddOn(undefined)
                            formik.setFieldValue('commodityInsurance', '')
                            formik.setFieldValue('insuranceAmount', '')
                            formik.setFieldValue('insuranceAddOn', undefined)
                            formik.setFieldValue('insuranceFreight', undefined)
                            formik.setFieldValue('coverTypeInsurance', '')
                            
                        }, 500);
                    })
                }
                else {
                    setFormikValues('redkikQuoteId', null)
                    setOpen(false)
                    setIsSavingInsurance(false)
                }
            }
            else if(open) {
                setOpen(false)
                formik.handleSubmit()
                setOpenErrorsInPageModal(true) 
                setInsuranceAmount(null)
                setTimeout(() => {                    
                    setSelectedAcc([])
                    setIsSavingInsurance(false)
                }, 500);
            }
           
        //}
        /*
        else {            
            setOpen(false)
            setOpenErrorsInPageModal(true)
            setFormikValues('moneyAccessorialsInformation[0]',                 
                {
                    insuranceAmount: values?.insuranceAmount,
                    insuranceFreight: values?.insuranceFreight,
                    insuranceAddOn: values?.insuranceAddOn,
                    commodityInsurance: values?.commodity,
                    accId: accessorialSelected.id,
                    typeName: accessorialSelected.typeName
                }
            )

            formik.setFieldError('pickupDate.date', 'must be a `date` type, but the final value was: `Invalid Date` (cast from the value `Invalid Date`).')
            formik.setTouched('pickupDate.date', true, true)
            
            setTouchedDate({
                pickup: true,
                delivery: false
              })

        }
        */
    }

    const saveInsurance = () => {
        if(!user?.redkikEnabled || (accessorialSelected.code === 'VINS' || accessorialSelected.code === 'COD' || accessorialSelected.code === 'FCCOD' || accessorialSelected.code === 'DV' || accessorialSelected.code === 'INS'  || accessorialSelected?.code === 'ArtSkh02' || accessorialSelected?.code === 'ArtSkh04')){
            if(!values?.insuranceAmount){
                setErrorCargoValue(true)
            }else{
                setInsuranceValuesInFormik()
                setErrorCargoValue(false)
                setErrorCommodity(false)                
            }
        }else{
            if(!values.insuranceAmount && values.commodity){
                setErrorCargoValue(true)
            }else if(values.insuranceAmount && !values.commodity){
                setErrorCommodity(true)
            }else if(!values.insuranceAmount && !values.commodity){
                setErrorCommodity(true)
                setErrorCargoValue(true)
            }else{
                setInsuranceValuesInFormik()
                setErrorCargoValue(false)
                setErrorCommodity(false)                
            }
        }
    }

    useEffect(() => {
      if(open){        
        if(user.redkikEnabled && accessorialSelected?.code == 'INS'){
            setLoading(true)
            if(!commodities.length) {
                axios.get(GET_COMMODITIES).then((results) => {
                    setCommodities(results.data.data.results)
                }).catch(error => {
                    checkErrorAPICall(error, dispatch, 'Commodities')
                })
            }
            if(!coverTypes.length) {
                axios.get(GET_COVERTYPES).then((results) => {
                    setCoverTypes(results.data.data.results)
                    setLoading(false)
                }).catch(error => {
                    setLoading(false)
                    checkErrorAPICall(error, dispatch, 'Cover Types')
                })
            } else {
                setLoading(false)
            }
        }
        let accesorialsToFind = formikValues?.moneyAccessorialsInformation?.length ? 
                                formikValues?.moneyAccessorialsInformation 
                                : 
                                formikValues?.accessorials?.other?.length ? formikValues?.accessorials?.other : null
                                
        let valuesLocal

        // if(formikValues?.moneyAccessorialsInformation?.length) {            
            // valuesLocal = accesorialsToFind?.find(a => (a.accId || a.id) === accessorialSelected.id)
            if(formikValues.accessorials?.other?.length) {
                valuesLocal = formikValues.accessorials?.other?.find(a => (a.accId || a.id) === accessorialSelected.id && a.code == 'INS')
                if(valuesLocal)  {
                    setValues({
                        commodity: formikValues?.commodityInsurance || undefined,
                        insuranceAmount: formikValues?.insuranceAmount || null,
                        insuranceFreight: formikValues?.insuranceFreight || false,
                        insuranceAddOn: formikValues?.insuranceAddOn || false,
                        accId: valuesLocal?.accId || valuesLocal?.id || null,
                        typeName: valuesLocal?.typeName || valuesLocal?.name,
                        coverTypeInsurance: formikValues?.coverTypeInsurance || undefined
                    })
                }
        }
        // else if(formikValues?.accessorials?.other?.length) {
        //     valuesLocal = accesorialsToFind?.find(a => a.id === accessorialSelected.id)
        //     setValues({
        //         commodity: formikValues?.commodityInsurance || undefined,
        //         insuranceAmount: formikValues?.insuranceAmount || null,
        //         insuranceFreight: formikValues?.insuranceFreight || false,
        //         insuranceAddOn: formikValues?.insuranceAddOn || false,
        //         accId: valuesLocal?.id || null,
        //         typeName: valuesLocal?.name
        //     })
        // }

        
      }else{
        setTimeout(() => {
            setAccessorialSelected({})
        }, 500);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])
 
    const menuProps = {
        classes: {
            list: classesInput.selectPaperList
        }
    }

    return (
        <>
            <ModalStyled
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                fontSize={fontSize}
                open={open}
                onClose={handleCloseModal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={accessorialSelected?.code === 'VINS' || accessorialSelected?.code === 'COD' || accessorialSelected?.code === 'FCCOD' ? classes.paperSaveQuoteSmall : classes.paperSaveQuote} style={{visibility: 'visible', opacity: '100%'}}>
                        <div className="row modal-header p-0 pb-2 row align-items-center">
                            <div className="col-6 d-flex align-items-center">
                                <h5>{accessorialSelected?.name}</h5>
                            </div>
                            <div className="col-6 d-flex justify-content-end">
                                <div
                                    className="btn btn-icon btn-sm btn-active-light-primary"
                                    onClick={handleCloseModal}
                                >
                                    <KTSVG
                                        path="/media/icons/duotune/arrows/arr061.svg"
                                        className="svg-icon svg-icon-2x"
                                    />
                                </div>
                            </div>
                        </div>
                        <>
                            {
                                accessorialSelected?.code !== 'VINS' && accessorialSelected?.code !== 'COD' && accessorialSelected?.code !== 'FCCOD'
                                ? 
                                    loading
                                    ? <div className="row mt-5 mb-5">
                                        <div className="col-12 d-flex justify-content-center">
                                            <CircularProgress style={{height: 40, width: 40, color: '#019ef7'}}/>
                                        </div>
                                    </div>
                                    : <div className="row mt-4">
                                        {
                                            user?.redkikEnabled && accessorialSelected?.code == 'INS' ?
                                                <div className="col-12 d-flex align-items-center mb-4">
                                                    <div className="me-5">Commodity</div>
                                                    <TextField
                                                        select
                                                        label=" "
                                                        value={values?.commodity}
                                                        onChange={(e) => {
                                                            if(!formikValues?.carrierInformation?.name){
                                                                setValues({...values, [e.target.name]: e.target.value})
                                                                if(e.target.value){
                                                                    setErrorCommodity(false)
                                                                }
                                                            }else{
                                                                let accessorialData = formikValues?.moneyAccessorialsInformation?.find(a => a.accId === accessorialSelected.id)
                                                                let idx = formikValues?.moneyAccessorialsInformation?.indexOf(accessorialData)

                                                                setNewValuesWhenRateCleared({
                                                                    valuesFor: `moneyAccessorialsInformation[${idx}].commodity`,
                                                                    originalValues: values.commodity,
                                                                    values: e.target.value,
                                                                    functionToDo: () => {
                                                                        setValues({...values, commodity: e.target.value})
                                                                        if(e.target.value){
                                                                            setErrorCommodity(false)
                                                                        }
                                                                    },
                                                                    functionToDoIfNo: () => {
                                                                        setValues({...values, commodity: values.commodity})
                                                                        if(values.commodity){
                                                                            setErrorCommodity(false)
                                                                        }
                                                                    }
                                                                })
                                                                setOpenClearRateToEditModal(true)
                                                            }
                                                        }}
                                                        name='commodity'
                                                        className={`${errorCommodity ? classesInput.selectMUIError : classesInput.selectMUI}`}
                                                        InputProps={{
                                                            style: stylesMUIInput(fontSize),
                                                        }}
                                                        SelectProps={{
                                                            IconComponent: KeyboardArrowDownIcon,
                                                            MenuProps: menuProps
                                                        }}
                                                        InputLabelProps={{shrink: false}}
                                                    >
                                                        {commodities.map((commodity, index) => {
                                                            return <MenuItem key={index} value={commodity.id}>{commodity.name}</MenuItem>
                                                        })}
                                                    </TextField>
                                                </div>
                                                : null
                                        }
                                        {
                                            user?.redkikEnabled && accessorialSelected?.code == 'INS' && user?.redkikInfo?.showCoverType ?
                                                <div className="col-12 d-flex align-items-center mb-4">
                                                    <div className="me-5">Cover Type</div>
                                                    <TextField
                                                        select
                                                        label=" "
                                                        value={values?.coverTypeInsurance}
                                                        onChange={(e) => {
                                                            if(!formikValues?.carrierInformation?.name){
                                                                setValues({...values, [e.target.name]: e.target.value})
                                                                if(e.target.value){
                                                                    setErrorCoverType(false)
                                                                }
                                                            }else{
                                                                let accessorialData = formikValues?.moneyAccessorialsInformation?.find(a => a.accId === accessorialSelected.id)
                                                                let idx = formikValues?.moneyAccessorialsInformation?.indexOf(accessorialData)

                                                                setNewValuesWhenRateCleared({
                                                                    valuesFor: `moneyAccessorialsInformation[${idx}].coverTypeInsurance`,
                                                                    originalValues: values.coverTypeInsurance,
                                                                    values: e.target.value,
                                                                    functionToDo: () => {
                                                                        setValues({...values, coverTypeInsurance: e.target.value})
                                                                        if(e.target.value){
                                                                            setErrorCoverType(false)
                                                                        }
                                                                    },
                                                                    functionToDoIfNo: () => {
                                                                        setValues({...values, coverTypeInsurance: values.coverTypeInsurance})
                                                                        if(values.coverTypeInsurance){
                                                                            setErrorCoverType(false)
                                                                        }
                                                                    }
                                                                })
                                                                setOpenClearRateToEditModal(true)
                                                            }
                                                        }}
                                                        name='coverTypeInsurance'
                                                        className={`${errorCoverType ? classesInput.selectMUIError : classesInput.selectMUI}`}
                                                        InputProps={{
                                                            style: stylesMUIInput(fontSize),
                                                        }}
                                                        SelectProps={{
                                                            IconComponent: KeyboardArrowDownIcon,
                                                            MenuProps: menuProps
                                                        }}
                                                        InputLabelProps={{shrink: false}}
                                                    >
                                                        {coverTypes.map((coverType, index) => {
                                                            return <MenuItem key={index} value={coverType.name}>{coverType.name}</MenuItem>
                                                        })}
                                                    </TextField>
                                                </div>
                                            : null
                                        }
                                        <div className="col-12 col-sm-6 d-flex align-items-center">
                                            <div className="w-50 me-4">Cargo value</div>
                                            <NumberFormatStyled
                                                className={`form-control ${errorCargoValue ? 'form-control-error' : false} me-3`}
                                                autoComplete="off"
                                                decimalScale={0}
                                                /*
                                                isAllowed={(values) => {
                                                    const { formattedValue, floatValue } = values;
                                                    return formattedValue === '' || (floatValue >= 0 && floatValue <= (accessorialSelected?.valueRequired?.max || 9999999))
                                                }}
                                                */
                                                fontSize={fontSize}
                                                value={insuranceAmount || values.insuranceAmount}
                                                name='insuranceAmount'
                                                onChange={(e) => {
                                                    if(formikValues?.carrierInformation?.name){
                                                        let accessorialData = formikValues?.moneyAccessorialsInformation?.find(a => a.accId === accessorialSelected.id)
                                                        let idx = formikValues?.moneyAccessorialsInformation?.indexOf(accessorialData)
    
                                                        setInsuranceAmount(e.target.value)
                                                        setNewValuesWhenRateCleared({
                                                            valuesFor: `moneyAccessorialsInformation[${idx}].insuranceAmount`,
                                                            originalValues: values.insuranceAmount,
                                                            values: e.target.value,
                                                            functionToDo: () => {
                                                                setInsuranceAmount(null)
                                                                setValues({...values, insuranceAmount: e.target.value})
                                                                if(e.target.value){
                                                                    setErrorCargoValue(false)
                                                                }
                                                            },
                                                            functionToDoIfNo: () => {
                                                                setInsuranceAmount(null)
                                                            }
                                                        })
                                                        setOpenClearRateToEditModal(true)
                                                    }else{
                                                        setValues({...values, [e.target.name]: e.target.value})
                                                        if(e.target.value){
                                                            setErrorCargoValue(false)
                                                        }
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="col-12 col-sm-6 mt-4 mt-sm-0 d-flex align-items-center">
                                            {
                                                !user?.redkikEnabled ?
                                                    <div className='form-check form-check-custom form-check-solid form-check-sm'>
                                                        <input
                                                            className='form-check-input'
                                                            type='checkbox'
                                                            id='addFreightCost'
                                                            name='insuranceFreight'
                                                            checked={insuranceFreight !== undefined ? insuranceFreight : values.insuranceFreight}
                                                            onClick={(e) => {
                                                                if(formikValues?.carrierInformation?.name){
                                                                    let accessorialData = formikValues?.moneyAccessorialsInformation?.find(a => a.accId === accessorialSelected.id)
                                                                    let idx = formikValues?.moneyAccessorialsInformation?.indexOf(accessorialData)

                                                                    setInsuranceFreight(e.target.checked)
                                                                    setNewValuesWhenRateCleared({
                                                                        valuesFor: `moneyAccessorialsInformation[${idx}].isuranceFreight`,
                                                                        originalValues: values.insuranceFreight,
                                                                        values: e.target.checked,
                                                                        functionToDo: () => {
                                                                            setInsuranceFreight(undefined)
                                                                            setValues({...values, insuranceFreight: e.target.checked})
                                                                        },
                                                                        functionToDoIfNo: () => {
                                                                            setInsuranceFreight(undefined)
                                                                        }
                                                                    })
                                                                    setOpenClearRateToEditModal(true)
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                if(!formikValues?.carrierInformation?.name){
                                                                    setValues({...values, [e.target.name]: e.target.checked})
                                                                }
                                                            }}
                                                        />
                                                        <label className='form-check-label me-4' htmlFor='addFreightCost'>Add Freight Cost</label>
                                                        <input
                                                            className='form-check-input'
                                                            type='checkbox'
                                                            id='10AddOn'
                                                            name='insuranceAddOn'
                                                            checked={insuranceAddOn !== undefined ? insuranceAddOn : values.insuranceAddOn}
                                                            onClick={(e) => {
                                                                if(formikValues?.carrierInformation?.name){
                                                                    let accessorialData = formikValues?.moneyAccessorialsInformation?.find(a => a.accId === accessorialSelected.id)
                                                                    let idx = formikValues?.moneyAccessorialsInformation?.indexOf(accessorialData)

                                                                    setInsuranceAddOn(e.target.checked)
                                                                    setNewValuesWhenRateCleared({
                                                                        valuesFor: `moneyAccessorialsInformation[${idx}].insuranceAddOn`,
                                                                        originalValues: values.insuranceAddOn,
                                                                        values: e.target.checked,
                                                                        functionToDo: () => {
                                                                            setInsuranceAddOn(undefined)
                                                                            setValues({...values, insuranceAddOn: e.target.checked})
                                                                        },
                                                                        functionToDoIfNo: () => {
                                                                            setInsuranceAddOn(undefined)
                                                                        }
                                                                    })
                                                                    setOpenClearRateToEditModal(true)
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                if(!formikValues?.carrierInformation?.name){
                                                                    setValues({...values, [e.target.name]: e.target.checked})
                                                                }
                                                            }}
                                                        />
                                                        <label className='form-check-label' htmlFor='10AddOn'>10% Add On</label>
                                                    </div>
                                                : null
                                            }
                                        </div>
                                    </div>
                                : <div className="row mt-4">
                                    <div className="col-12 d-flex align-items-center">
                                        <div className="w-50 me-4">{accessorialSelected?.code} value</div>
                                        <NumberFormatStyled
                                            className={`form-control ${errorCargoValue ? 'form-control-error' : false}`}
                                            autoComplete="off"
                                            decimalScale={0}
                                            /*
                                            isAllowed={(values) => {
                                                const { formattedValue, floatValue } = values;
                                                return formattedValue === '' || (floatValue >= 0)
                                            }}
                                            */
                                            fontSize={fontSize}
                                            value={insuranceAmount || values.insuranceAmount}
                                            name='insuranceAmount'
                                            onChange={(e) => {
                                                if(formikValues?.carrierInformation?.name){
                                                    let accessorialData = formikValues?.moneyAccessorialsInformation?.find(a => a.accId === accessorialSelected.id)
                                                    let idx = formikValues?.moneyAccessorialsInformation?.indexOf(accessorialData)

                                                    setInsuranceAmount(e.target.value)
                                                    setNewValuesWhenRateCleared({
                                                        valuesFor: `moneyAccessorialsInformation[${idx}].insuranceAmount`,
                                                        originalValues: values.insuranceAmount,
                                                        values: e.target.value,
                                                        functionToDo: () => {
                                                            setInsuranceAmount(null)
                                                            setValues({...values, insuranceAmount: e.target.value})
                                                            if(e.target.value){
                                                                setErrorCargoValue(false)
                                                            }
                                                        },
                                                        functionToDoIfNo: () => {
                                                            setInsuranceAmount(null)
                                                        }
                                                    })
                                                    setOpenClearRateToEditModal(true)
                                                }else{
                                                    setValues({...values, [e.target.name]: e.target.value})
                                                    if(e.target.value){
                                                        setErrorCargoValue(false)
                                                    }
                                                }
                                            }}
                                        />
                                     </div>
                                </div>
                            }
                            <div className="row mt-4 mb-3">
                                {
                                    accessorialSelected?.code !== 'VINS' && accessorialSelected?.code !== 'COD' && accessorialSelected?.code !== 'FCCOD' ?
                                    <div className="col-12 d-flex align-items-center mb-4">
                                        <div style={{overflowWrap: 'anywhere', fontStyle: 'italic', fontWeight: 500}}>{user?.insuranceDisclaimer}</div>
                                    </div>
                                    : null
                                }
                                <div className="col-12 mt-4 mt-sm-0 d-flex justify-content-end align-items-center">
                                    {accessorialSelected?.code !== 'VINS' && accessorialSelected?.code !== 'COD' && accessorialSelected?.code !== 'FCCOD' ? (errorCargoValue || errorCommodity) : false ? <div style={{fontStyle: 'italic'}} className='text-danger me-5'>Highlighted fields are required</div> : null}
                                    <button className="btn btn-secondary me-4 " onClick={handleCloseModal}>
                                        Close
                                    </button>
                                    <button className="btn btn-primary" disabled={isSavingInsurance} onClick={saveInsurance}>
                                        <>
                                        {isSavingInsurance ? <CircularProgress style={{height: 15, width: 15, color: '#ffffff', marginRight: '5px'}}/>  : null}
                                        Save
                                        </>
                                    </button>
                                </div>
                            </div>
                        </>
                    </div>
                </Fade>
            </ModalStyled>
            <InsuranceErrorModal
                open={openInsuranceErrorModal}
                restError={insuranceErrorMessage}
                setOpen={setOpenInsuranceErrorModal}
            />
        </>
    )
}

export default InsuranceModal